import React from 'react';
import './LOFAScheduleDisplayMode.css';
import LOFAScheduleDetailItem from '../LOFAScheduleDetailItem/LOFAScheduleDetailItem';
import { GetLofaSchedule_getLofaSchedule as LOFAScheduleSummaryData } from '../../../../types/schemaTypes';
import { PermissionEnum } from '../../../../types/PermissionEnum';
import { useAuthContext } from '../../../Auth/AuthProvider';

interface LOFAScheduleDisplayModeProps {
    lofaScheduleSummaryList: LOFAScheduleSummaryData[];
    changeEditMode: () => void;
    isJobCompleted: boolean;
}

const LOFAScheduleDisplayMode = ({
    lofaScheduleSummaryList,
    changeEditMode,
    isJobCompleted,
}: LOFAScheduleDisplayModeProps): React.ReactElement => {
    const isEditEnabled = useAuthContext().userHasPermission(PermissionEnum.EditLOFASchedule);
    return (
        <div>
            {!isJobCompleted && isEditEnabled && (
                <div
                    className="LOFASchedule-Link-Container Row justify-content-end"
                    onClick={(): void => changeEditMode()}
                >
                    <i className="material-icons LOFASchedule-Edit-Icon">create</i>
                    <span className="LOFASchedule-Edit-Link">Edit</span>
                </div>
            )}
            <LOFAScheduleDetailItem lofaScheduleSummaryList={lofaScheduleSummaryList} />
        </div>
    );
};

export default LOFAScheduleDisplayMode;

